/**
 * Header AI Usage pill — shows current user's monthly AI spend / cap with tone.
 * Clickable → jumps to /settings on Cost tab. Refreshes every 60s.
 */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Zap } from "lucide-react";

const TONES = {
  ok:      "border-border/50 text-muted-foreground hover:text-foreground",
  info:    "border-[#0A84FF]/50 text-[#0A84FF]",
  warn:    "border-signal-yellow/60 text-signal-yellow",
  crit:    "border-signal-red/60 text-signal-red",
};

export default function AIUsagePill() {
  const [data, setData] = useState(null);
  const nav = useNavigate();
  const load = async () => {
    try {
      const { data } = await api.get("/workspace/ai-cost-usage-summary");
      setData(data);
    } catch { /* ignore */ }
  };
  useEffect(() => { load(); const t = setInterval(load, 60000); return () => clearInterval(t); }, []);
  if (!data) return null;
  const cfg = data.config || {};
  const used = data.user_month || 0;
  const cap = cfg.monthly_per_user_usd || 1;
  const pct = Math.min(100, Math.round((used / cap) * 100));
  const tone = pct >= 100 ? "crit" : pct >= 90 ? "warn" : pct >= 75 ? "info" : "ok";
  return (
    <button
      onClick={() => nav("/settings")}
      className={`h-7 px-2 border ${TONES[tone]} mono text-[10px] uppercase tracking-widest flex items-center gap-1.5 transition-colors`}
      title={`Monthly AI spend: $${used.toFixed(4)} of $${cap} (${pct}%)`}
      data-testid="ai-usage-pill"
    >
      <Zap size={11} strokeWidth={1.5} />
      AI ${used.toFixed(2)}/${cap} · {pct}%
    </button>
  );
}
